export default __webpack_public_path__ + "media/call-o.c76bef57.svg";